"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SvgIconSizes = exports.SvgIconFillTypes = exports.Storybook = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireWildcard(require("react"));
var _reactJss = require("react-jss");
var _SvgIconsMap = _interopRequireDefault(require("../../components/SvgIconsMap"));
var _createUseStyles = _interopRequireDefault(require("../../themes/createUseStyles"));
var _Theme = require("../../themes/Theme");
var _defaultProps = _interopRequireDefault(require("../../utils/defaultProps"));
var _omit = _interopRequireDefault(require("../../utils/omit"));
var _pickAndRemoveFromObject = _interopRequireDefault(require("../../utils/pickAndRemoveFromObject"));
var _commonProps = require("../../utils/vars/commonProps");
var _initVars = _interopRequireDefault(require("../../utils/vars/initVars"));
var _excluded = ["className", "fill", "name", "overrides", "dropShadow", "size", "title", "viewBox"];
/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
var common = _commonProps.defaultCommonProps;
var vars = (0, _initVars.default)({
  applied: common,
  variables: [{
    key: "rootTransform"
  }, {
    key: "iconSize"
  }, {
    key: "iconFill",
    canHaveColor: true
  }]
});

/**
 * @deprecated use 'StatusLevels' instead.
 */
var SvgIconFillTypes = exports.SvgIconFillTypes = /*#__PURE__*/function (SvgIconFillTypes) {
  SvgIconFillTypes["PRIMARY"] = "primary";
  SvgIconFillTypes["HIGHCONTRAST"] = "highContrast";
  SvgIconFillTypes["ALERT"] = "error";
  return SvgIconFillTypes;
}({});
/**
 * @deprecated use 'Sizes' instead.
 */
var SvgIconSizes = exports.SvgIconSizes = /*#__PURE__*/function (SvgIconSizes) {
  SvgIconSizes["SMALL"] = "small";
  SvgIconSizes["MEDIUM"] = "medium";
  SvgIconSizes["LARGE"] = "large";
  return SvgIconSizes;
}({});
var CUSTOM_SIZE = "customSize";
var generateSizeClass = function generateSizeClass(size) {
  return typeof size === "number" ? CUSTOM_SIZE : size;
};
var sizeStyle = function sizeStyle(size, theme) {
  return {
    minWidth: theme.iconSizes[size],
    minHeight: theme.iconSizes[size],
    width: theme.iconSizes[size],
    height: theme.iconSizes[size]
  };
};

// some svg icons need to be flipped / mirrored for right-to-left languages
var directionSpecificIcons = ["arrowBack", "arrowRightBoldCirle", "arrowForward", "chevronRight", "chevronLeft", "expandRight", "expandLeft", "logout", "openInNew", "reply", "refresh", "send", "subdirectoryArrowRight"];
var SvgIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var theme = (0, _reactJss.useTheme)();
  var className = props.className,
    _props$fill = props.fill,
    fill = _props$fill === void 0 ? "default" : _props$fill,
    name = props.name,
    _props$overrides = props.overrides,
    overrides = _props$overrides === void 0 ? {} : _props$overrides,
    dropShadow = props.dropShadow,
    _props$size = props.size,
    size = _props$size === void 0 ? "medium" : _props$size,
    title = props.title,
    _props$viewBox = props.viewBox,
    viewBox = _props$viewBox === void 0 ? "0 0 24 24" : _props$viewBox,
    otherProps = _objectWithoutProperties(props, _excluded);
  var classes = useStyles(vars.useVars(_objectSpread(_objectSpread({
    rootTransform: theme.direction === _Theme.Direction.rtl && directionSpecificIcons.includes(props.name) ? "scaleX(-1)" : "none"
  }, (0, _pickAndRemoveFromObject.default)(otherProps, common)), {}, {
    iconSize: size,
    iconFill: theme.colors[fill] || fill
  })));
  var fillClass = classes[fill] || classes.fill;
  var iconOverride = theme !== null && theme !== void 0 && theme.svgIconsMapOverrides ? theme.svgIconsMapOverrides[name] : null;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    ref: ref,
    className: (0, _classnames.default)(classes.variables, classes.root, _defineProperty({}, classes.dropShadow, dropShadow), classes[generateSizeClass(size)], fillClass, overrides.root, className),
    viewBox: viewBox
  }, (0, _omit.default)(_toConsumableArray(common), otherProps)), title && /*#__PURE__*/_react.default.createElement("title", null, title), iconOverride !== null && iconOverride !== void 0 ? iconOverride : _SvgIconsMap.default[name]);
});
var styles = function styles(theme) {
  return _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({
    variables: vars.styles,
    root: {
      boxSizing: "content-box",
      transform: vars.get("rootTransform"),
      display: "inline-block",
      verticalAlign: "middle"
    },
    small: sizeStyle("small", theme),
    medium: sizeStyle("medium", theme),
    large: sizeStyle("large", theme)
  }, CUSTOM_SIZE, {
    minWidth: vars.get("iconSize"),
    minHeight: vars.get("iconSize"),
    width: vars.get("iconSize"),
    height: vars.get("iconSize")
  }), "dropShadow", {
    filter: "drop-shadow(0.4px 1px 1px rgba(0, 0, 0, 0.4))"
  }), "default", {
    fill: theme.colors.baseInvariant
  }), "primary", {
    fill: theme.colors.primary
  }), "highContrast", {
    fill: theme.colors.baseContrast100
  }), "warning", {
    fill: theme.colors.warning
  }), "error", {
    fill: theme.colors.alert
  }), "success", {
    fill: theme.colors.success
  }), "fill", {
    fill: vars.get("iconFill")
  });
};
var useStyles = (0, _createUseStyles.default)(styles, {
  name: "SvgIcon"
});
SvgIcon.displayName = "SvgIcon";
var Storybook = exports.Storybook = SvgIcon;

/**
 * @see https://icfreactcomponents.integ.icfsys.com/?path=/docs/information-svgicon--docs
 */
var exportedComponent = (0, _defaultProps.default)(SvgIcon);
exportedComponent.displayName = "SvgIcon";
var _default = exports.default = exportedComponent;